'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './components/HeroSection';
import TransformationPathway from './components/TransformationPathway';
import IndustryPortals from './components/IndustryPortals';
import ProductEcosystem from './components/ProductEcosystem';
import BusinessImpactSection from './components/BusinessImpactSection';
import TrustSignals from './components/TrustSignals';
import SuccessStories from './components/SuccessStories';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ContactSalesModal from '@/components/ContactSalesModal';

export default function Homepage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Check if modal has been auto-opened before
    const hasAutoOpened = localStorage.getItem('contactSalesAutoOpened');
    
    if (!hasAutoOpened) {
      // Random delay between 15-20 seconds (15000-20000ms)
      const delay = Math.floor(Math.random() * 5000) + 15000;
      
      const timer = setTimeout(() => {
        setIsModalOpen(true);
        localStorage.setItem('contactSalesAutoOpened', 'true');
      }, delay);

      return () => clearTimeout(timer);
    }
  }, []);

  // Function to open modal (will be passed to child components)
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header onContactSalesClick={openModal} />
      
      <main className="pt-16">
        <HeroSection />
        
        {/* Section Separator */}
        <div className="py-2 bg-gradient-to-b from-background to-surface">
          <div className="container mx-auto px-4">
            <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent"></div>
          </div>
        </div>
        
        <TransformationPathway />
        
        {/* Section Separator */}
        <div className="py-1 bg-gradient-to-b from-surface to-background">
          <div className="container mx-auto px-4">
            <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent"></div>
          </div>
        </div>
        
        <ProductEcosystem />
        
        <BusinessImpactSection />
        
        <IndustryPortals />
        <TrustSignals />
        
        <SuccessStories />
        
        <CTASection onContactSalesClick={openModal} />
      </main>

      <Footer />
      
      {/* Contact Sales Modal */}
      <ContactSalesModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}